import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './Signal.module.css';
import signalVehicleRed from '../../assets/signal_veh_red.svg';
import signalVehicleAmber from '../../assets/signal_veh_yellow.svg';
import signalVehicleGreen from '../../assets/signal_veh_green.svg';
import signalVehicleUndef from '../../assets/signal_veh_undef.svg';
import signalVehicleAmberRed from '../../assets/signal_veh_yellow_red.svg';
import signalVehicleRvRed from '../../assets/signal_veh_rv_red.svg';
import signalVehicleRvAmber from '../../assets/signal_veh_rv_yellow.svg';
import signalVehicleRvGreen from '../../assets/signal_veh_rv_green.svg';
import signalVehicleRvUndef from '../../assets/signal_veh_rv_undef.svg';
import signalLeftRed from '../../assets/signal_veh_left_red.svg';
import signalLeftAmber from '../../assets/signal_veh_left_yellow.svg';
import signalLeftAmberRed from '../../assets/signal_veh_left_yellow_red.svg'; // New
import signalLeftGreen from '../../assets/signal_veh_left_green.svg';
import signalRightRed from '../../assets/signal_veh_right_red.svg';
import signalRightAmber from '../../assets/signal_veh_right_yellow.svg';
import signalRightAmberRed from '../../assets/signal_veh_right_yellow_red.svg'; // New
import signalRightGreen from '../../assets/signal_veh_right_green.svg';
import signalLeft2Red from '../../assets/signal_veh_left2_red.svg';
import signalLeft2Amber from '../../assets/signal_veh_left2_yellow.svg';
import signalLeft2Green from '../../assets/signal_veh_left2_green.svg';
import signalRight2Red from '../../assets/signal_veh_right2_red.svg';
import signalRight2Amber from '../../assets/signal_veh_right2_yellow.svg';
import signalRight2Green from '../../assets/signal_veh_right2_green.svg';
import signalLeft1Red from '../../assets/signal_veh_left1_red.svg';
import signalLeft1Amber from '../../assets/signal_veh_left1_yellow.svg';
import signalLeft1Green from '../../assets/signal_veh_left1_green.svg';
import signalRight1Red from '../../assets/signal_veh_right1_red.svg';
import signalRight1Amber from '../../assets/signal_veh_right1_yellow.svg';
import signalRight1Green from '../../assets/signal_veh_right1_green.svg';
import signalLeftUndef from '../../assets/signal_veh_left_undef.svg'; // New
import signalRightUndef from '../../assets/signal_veh_right_undef.svg'; // New
import signalLeft2Undef from '../../assets/signal_veh_left2_undef.svg'; // New
import signalRight2Undef from '../../assets/signal_veh_right2_undef.svg'; // New
import signalLeft1Undef from '../../assets/signal_veh_left1_undef.svg'; // New
import signalRight1Undef from '../../assets/signal_veh_right1_undef.svg'; // New
import signalTrolleyRed from '../../assets/signal_tro_red.svg';
import signalTrolleyAmber from '../../assets/signal_tro_yellow.svg';
import signalTrolleyGreen from '../../assets/signal_tro_green.svg';
import signalTrolleyUndef from '../../assets/signal_tro_undef.svg';
import signalTrolleyPedestrianOff from '../../assets/signal_ped_tro_green.svg';
import signalTrolleyPedestrianOn from '../../assets/signal_ped_tro_red.svg';
import signalTrolleyPedestrianUndef from '../../assets/signal_ped_tro_undef.svg';
import signalTrolleyAmberRed from '../../assets/signal_tro_yellow_red.svg';
import signalPedestrianRed from '../../assets/signal_ped_red.svg';
import signalPedestrianAmber from '../../assets/signal_ped_amber.svg';
import signalPedestrianGreen from '../../assets/signal_ped_green.svg';
import signalPedestrianUndef from '../../assets/signal_ped_undef.svg';
import signalPrioOn from '../../assets/signal_prio_on.svg';
import signalPrioOff from '../../assets/signal_prio_off.svg';
import signalPrioUndef from '../../assets/signal_prio_undef.svg';
import { FaRegCompass } from 'react-icons/fa';
import { isPedestrianSignal, isPrioritySignal, isTrolleyPedestrianSignal, isTrolleySignal, SIGNAL_TYPES } from "../trafficInfra/SignalTypes";
import { greens, ambers, amberReds, reds, undefineds, GREEN, AMBER, AMBER_REDS, RED, UNDEF, stateDescriptions } from './signalStates';

const Signal = (props) => {
    const signal = props.signal;


    const statusCodes = new Map([
        ...greens.map((i) => [i, GREEN]),
        ...ambers.map((i) => [i, AMBER]),
        ...amberReds.map((i) => [i, AMBER_REDS]),
        ...reds.map((i) => [i, RED]),
        ...undefineds.map((i) => [i, UNDEF])]);

    const getSignalIcon = (signal) => {
        const status = statusCodes.get(signal.status);

        if (isPedestrianSignal(signal)) {
            switch (status) {
                case RED: return signalPedestrianRed;
                case AMBER: return signalPedestrianAmber;
                case GREEN: return signalPedestrianGreen;
                default: return signalPedestrianUndef;
            }
        } else if (isTrolleyPedestrianSignal(signal)) {
            switch (status) {
                case RED: return signalTrolleyPedestrianOff;
                case GREEN: return signalTrolleyPedestrianOn;
                default: return signalTrolleyPedestrianUndef;
            }
        } else if (isTrolleySignal(signal)) {
            switch (status) {
                case RED: return signalTrolleyRed;
                case AMBER: return signalTrolleyAmber;
                case GREEN: return signalTrolleyGreen;
                case AMBER_REDS: return signalTrolleyAmberRed;
                default: return signalTrolleyUndef;
            }
        } else if (isPrioritySignal(signal)) {
            switch (status) {
                case RED: return signalPrioOff;
                case GREEN: return signalPrioOn;
                default: return signalPrioUndef;
            }
        } else {
            const type = signal.type ? signal.type.toLowerCase() : SIGNAL_TYPES.STRAIGHT;

            const select = (r, y, g, yr, u) => {
                switch (status) {
                    case RED: return r;
                    case AMBER: return y;
                    case GREEN: return g;
                    case AMBER_REDS: return yr || r;
                    default: return u || signalVehicleUndef;
                }
            };

            switch (type) {
                case SIGNAL_TYPES.STRAIGHT_RV:
                    return select(signalVehicleRvRed, signalVehicleRvAmber, signalVehicleRvGreen, null, signalVehicleRvUndef);
                case SIGNAL_TYPES.LEFT:
                    return select(signalLeftRed, signalLeftAmber, signalLeftGreen, signalLeftAmberRed, signalLeftUndef);
                case SIGNAL_TYPES.RIGHT:
                    return select(signalRightRed, signalRightAmber, signalRightGreen, signalRightAmberRed, signalRightUndef);
                case SIGNAL_TYPES.LEFT_2:
                    return select(signalLeft2Red, signalLeft2Amber, signalLeft2Green, null, signalLeft2Undef);
                case SIGNAL_TYPES.RIGHT_2:
                    return select(signalRight2Red, signalRight2Amber, signalRight2Green, null, signalRight2Undef);
                case SIGNAL_TYPES.LEFT_1:
                    return select(signalLeft1Red, signalLeft1Amber, signalLeft1Green, null, signalLeft1Undef);
                case SIGNAL_TYPES.RIGHT_1:
                    return select(signalRight1Red, signalRight1Amber, signalRight1Green, null, signalRight1Undef);
                default:
                    switch (status) {
                        case RED: return signalVehicleRed;
                        case AMBER: return signalVehicleAmber;
                        case GREEN: return signalVehicleGreen;
                        case AMBER_REDS: return signalVehicleAmberRed;
                        default: return signalVehicleUndef;
                    }
            }
        }
    };

    const signalIcon = getSignalIcon(signal);
    const { t } = useTranslation();

    return (
        <div className={classes.Signal} style={{ opacity: signal.isDimmed ? 0.3 : 1 }}>
            <FaRegCompass title={t('signal.direction')} /> {signal.name}<br />

            <div className={classes.SignalContainer}>
                <img
                    className={isTrolleyPedestrianSignal(signal) ? classes.SignalHorizontal : classes.Signal}
                    src={signalIcon}
                    alt={statusCodes.get(signal.status)}
                    title={`${signal.status}: ${stateDescriptions[signal.status]?.short}`}
                />
            </div>

        </div>
    );
};

export default Signal;
